import {
  CHARCOAL_90,
  OwnUpBody,
  OwnUpGridBreak,
  OwnUpGridContainer,
  OwnUpGridItem,
  OwnUpGridOffset,
  OwnUpGridWrapper,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';

const DisclamerWrapper = styled.section`
  background-color: ${CHARCOAL_90};
  padding-top: ${({ theme }) => theme.spacing(4)}px;
  padding-bottom: ${({ theme }) => theme.spacing(11)}px;
  color: white;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('lg')} {
    padding-bottom: ${({ theme }) => theme.spacing(4)}px;
  }
`;
const DisclamerHeader = styled.span`
  font-size: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(2)}px;
`;

const DisclamerBody = styled(OwnUpBody)`
  font-size: 12px;
  line-height: 16px;
  margin-top: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(2)}px;
`;

export const DisclamerBlock = () => (
  <DisclamerWrapper aria-label="Disclamer">
    <OwnUpGridWrapper>
      <OwnUpGridContainer variant="slim">
        <OwnUpGridOffset xs={0} xl={6} />
        <OwnUpGridItem sm={12} md={12} lg={6}>
          <DisclamerHeader>Disclaimer</DisclamerHeader>
        </OwnUpGridItem>
        <OwnUpGridBreak />
        <OwnUpGridOffset xs={0} xl={6} />
        <OwnUpGridItem sm={12} md={12} lg={6}>
          <OwnUpGridBreak />
          <DisclamerBody variant="body1">
            The information provided to you in Own Up blog is intended to be for general
            informational and educational purposes only and does not constitute legal or tax advice.
            This blog is not a substitute for obtaining legal or tax advice from a qualified
            professional. The views and opinions expressed on this blog are solely those of the
            authors and do not necessarily reflect the official policy or position of Own Up or
            describe Own Up's business model. Own Up makes no representations or warranties of any
            kind, express or implied, about the completeness, accuracy, reliability, suitability or
            availability with respect to the blog or the information, products, services, or related
            graphics contained on the blog for any purpose. Any reliance you place on such
            information is therefore strictly at your own risk.
          </DisclamerBody>
        </OwnUpGridItem>
        <OwnUpGridBreak />
      </OwnUpGridContainer>
    </OwnUpGridWrapper>
  </DisclamerWrapper>
);
